import { BaseModel } from './base';
import { ResponseColumn } from './response';
import { FilterGroup } from './filter';
import { Option } from './option';
import { Method } from './method';
import { WidgetColumn } from './widget';

export class CaseOverviewMetaData extends BaseModel {
    public caption: string;
    public columns: ResponseColumn[];
    public filterGroups: FilterGroup[];
    public methods: Method[];
    public options: Option;
    public paginationCount: [];
    public sortFields: [];
    public table: string;
    public availableColumns: WidgetColumn[];

    constructor(json?: any) {
        super(json);
    }

    protected setObjectMappings(json: any): any {
        return Object.assign(super.setObjectMappings(json), {
            columns: json && json.columns ? json.columns.map((jsonValue: any) => new ResponseColumn(jsonValue)) : [],
            filterGroups: json && json.filterGroups ? json.filterGroups.map((jsonValue: any) => new FilterGroup(jsonValue)) : [],
            methods: json && json.methods ? json.methods.map((jsonValue: any) => new Method(jsonValue)) : [],
            paginationCount: json && json.paginationCount ? json.paginationCount.map((jsonValue: any) => jsonValue) : [],
            sortFields: json && json.sortFields ? json.sortFields.map((jsonValue: any) => jsonValue) : [],
            options: json && json.options ? new Option(json.options) : null,
            availableColumns: json && json.columns ? json.columns.map((jsonValue: any) => new WidgetColumn(jsonValue)) : [],
        });
    }

    public getFilterGroupById(id: string): FilterGroup {
        return this.filterGroups.find(group => group.id === id);
    }
}
